import { DiscountTable } from '@photosi/rn-components/discount-table/DiscountTable';
import Spinner from '@photosi/rn-components/spinner/Spinner';
import TextLato from '@photosi/rn-components/text/text-lato/TextLato';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { View } from 'react-native';
import Animated, { FadeIn, FadeOut } from 'react-native-reanimated';
import { useStore } from 'src/contexts/StoreContext';
import useResponsiveScreen from 'src/hooks/useResponsiveScreen';
import { styleDesktop, styleMobile } from './ModalUploadMultisourceBar.styles';
import { ModalUploadMultisourceBarProps } from './ModalUploadMultisourceBar.types';
import { ProgressBar } from '@photosi/rn-components/progress-bar/ProgressBar';

export const ModalUploadMultisourceBar = observer((props: ModalUploadMultisourceBarProps) => {
  const {
    isLoadingPercentageBarVisible = false,
    isSpinnerVisible = false,
    selectedThumbnailsCount = 0,
    discountScales = [],
    percentage,
  } = props;
  const { i18n } = useStore();
  const { isMobile } = useResponsiveScreen();
  const style = isMobile ? styleMobile : styleDesktop;

  let renderer = <></>;
  if (isLoadingPercentageBarVisible) {
    renderer = (
      <Animated.View style={style.progress} entering={FadeIn.duration(300)} exiting={FadeOut.duration(300)}>
        <View
          style={[
            style.wrapperLeft,
            isMobile &&
              isSpinnerVisible && {
                flexShrink: 10,
                flexGrow: 1,
              },
          ]}
        >
          {isSpinnerVisible ? (
            <Spinner width={21} height={21} />
          ) : (
            <View style={style.progressBarWrapper}>
              <ProgressBar progress={percentage} />
            </View>
          )}
        </View>
        <View style={[style.wrapperRight, isMobile && isSpinnerVisible && { flexShrink: 1, flexGrow: 10 }]}>
          <TextLato style={style.footerText} numberOfLines={1}>
            {i18n.t('modal-picker-my-photos:progress')}
          </TextLato>
        </View>
      </Animated.View>
    );
  } else if (selectedThumbnailsCount > 0 && discountScales?.length > 1) {
    renderer = (
      <Animated.View style={style.tableDiscount} entering={FadeIn.duration(300)} exiting={FadeOut.duration(300)}>
        <DiscountTable quantity={selectedThumbnailsCount} discount={discountScales} isMobile={isMobile} />
      </Animated.View>
    );
  }

  return renderer;
});
